export abstract class StringHelper {
  static isHtmlStringNotEmpty(value: string | undefined | boolean): boolean {
    if (!value) {
      return false
    }
    return value !== "-" && value !== "<br />"
  }
}
